export default "__VITE_ASSET__17025d97__"